module.exports = __webpack_public_path__ + "img/message_4.c381da01.png";